import {
  GET_CATEGORY_ORGANIZATION,
  CREATE_CATEGORY_ORGANIZATION,
  DELETE_CATEGORY_ORGANIZATION,
  UPDATE_CATEGORY_ORGANIZATION,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

const INIT_STATE = {
  categoryOrganizations: [],
  error: {},
  success: "",
};

const CategoryOrganization = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CATEGORY_ORGANIZATION:
          return {
            ...state,
            categoryOrganizations: action.payload.data,
            success: "",
            error: {},
          };
        case CREATE_CATEGORY_ORGANIZATION:
          return {
            ...state,
            success: "Sucessfully created category organization",
            error: {},
          };
        case UPDATE_CATEGORY_ORGANIZATION:
          return {
            ...state,
            success: "Sucessfully updated category organization",
            error: {},
          };
        case DELETE_CATEGORY_ORGANIZATION:
          return {
            ...state,
            success: "Sucessfully delete category organization",
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_CATEGORY_ORGANIZATION:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case CREATE_CATEGORY_ORGANIZATION:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case UPDATE_CATEGORY_ORGANIZATION:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case DELETE_CATEGORY_ORGANIZATION:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    case GET_CATEGORY_ORGANIZATION: {
      return {
        ...state,
      };
    }
    case CREATE_CATEGORY_ORGANIZATION: {
      return {
        ...state,
      };
    }
    case UPDATE_CATEGORY_ORGANIZATION: {
      return {
        ...state,
      };
    }
    case DELETE_CATEGORY_ORGANIZATION: {
      return {
        ...state,
      };
    }
    default:
      return { ...state };
  }
};

export default CategoryOrganization;
